<template>
    <div id="profilepage">
        <actions-menu>
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/stockcount')"
                icon="arrow-left"
                :label="trans('pages.profilepage.actions.back_to_overview')"
            />
            <actions-menu-item
                :v4="true"
                :action="() => $router.push('/editprofilepage/' + idParam)"
                icon="pencil"
                :label="trans('pages.profilepage.actions.edit')"
            />
            <actions-menu-item
                :v4="true"
                v-if="profile"
                :action="printProfileLabelClick"
                icon="tag"
                :label="trans('pages.profilepage.actions.print_article_label')"
            />
            <actions-menu-item
                :v4="true"
                v-if="profile"
                :action="printKanban"
                icon="tag"
                :label="trans('pages.profilepage.actions.print_kanban_label')"
            />
            <actions-menu-item
                :v4="true"
                v-if="profile"
                :action="removeProfile"
                class="alert"
                icon="trash-o"
                :label="trans('pages.profilepage.actions.delete')"
            />
            <actions-menu-item
                :v4="true"
                v-if="profile"
                :action="() => $router.push('/copyprofilepage?copy=' + idParam)"
                icon="copy"
                :label="trans('pages.profilepage.actions.duplicate')"
            />
            <actions-menu-item
                :v4="true"
                v-if="profile"
                :action="() => $router.push('/profilehistorypage/' + idParam)"
                icon="history"
                :label="trans('pages.profilepage.actions.history')"
            />
            <actions-menu-item
                :v4="true"
                :action="exportKanbanLabel"
                icon="list-alt"
                :label="trans('pages.profilepage.actions.export_kanban')"
            />
        </actions-menu>
        <div class="leftcolumn">
            <div v-if="profile">
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.description_nl') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.description }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.description_fr') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.descriptionFR }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.article_number') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.code }}</div>
                </div>

                <h2>{{ trans('pages.profilepage.fields.general_data') }}</h2>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.technical_sheet') }}
                    </div>
                    <div class="profilepagevalue">
                        <a
                            @click="openTechnical"
                            v-if="profile.technicalFichePath"
                        >
                            {{
                                trans('pages.profilepage.fields.download_here')
                            }}
                        </a>
                        <template v-else>
                            {{
                                trans(
                                    'pages.profilepage.fields.no_sheet_available'
                                )
                            }}
                        </template>
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.group') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.groupName }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.subgroup') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.subgroupName }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.stock_group') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.stockgroupName }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.supplier') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.supplierName }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{
                            trans('pages.profilepage.fields.manufacturer_code')
                        }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.supplierCode }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.supplier_code') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.supplierProfileCode }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.barcode') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.barcode }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.goods_type') }}
                    </div>
                    <div class="profilepagevalue">{{ goodsTypeLabel }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.extra_info') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.info }}</div>
                </div>
                <h2>
                    {{ trans('pages.profilepage.fields.stocks_and_packaging') }}
                </h2>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.weight_per_unit') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.weight }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.packaging_weight') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.weightBox }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.unit') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.unitName }}</div>
                </div>
                <div class="profilepagefield translations">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.packaging_length') }}
                    </div>
                    <div class="profilepagevalue">
                        <translations-display
                            v-if="profile.translations.packagePerUnit"
                            :translation-data="
                                profile.translations.packagePerUnit
                            "
                        />
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.count_per_kg') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.countPerKg }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.keep_stock') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            profile.keepStock == 1
                                ? trans('pages.profilepage.fields.true')
                                : trans('pages.profilepage.fields.false')
                        }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.count_sequence') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.countsequence }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.min_stock') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.minStock }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.max_stock') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.maxStock }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.stock') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.currentstockcount }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.spare_stock') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.spareStock }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.last_count') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            getFormattedDate(
                                new Date(profile.latestCount * 1000)
                            )
                        }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.shelf') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.location }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.shelf_2') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.location2 }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.bin_location') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.binLocation }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.order_quantity') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.descriptionKanban }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.delivery_period') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.deliveryPeriod }}
                    </div>
                </div>

                <template v-if="hasRight('administration')">
                    <h2>{{ trans('pages.profilepage.fields.prices') }}</h2>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.profilepage.fields.price_list') }}
                        </div>
                        <div class="profilepagevalue">
                            {{
                                profile.pricelist == 1
                                    ? trans('pages.profilepage.fields.true')
                                    : trans('pages.profilepage.fields.false')
                            }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{
                                trans(
                                    'pages.profilepage.fields.last_price_check'
                                )
                            }}
                        </div>
                        <div class="profilepagevalue">
                            {{
                                getFormattedDate(
                                    new Date(profile.latestPriceControl * 1000)
                                )
                            }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.profilepage.fields.eosol_vp') }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.eosolPrice }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{
                                trans('pages.profilepage.fields.eosol_price_lm')
                            }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.EosolPriceLM || '' }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{
                                trans(
                                    'pages.profilepage.fields.eosol_price_lm_coating'
                                )
                            }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.EosolPriceLMCoating || '' }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{
                                trans(
                                    'pages.profilepage.fields.eosol_buy_price_lm'
                                )
                            }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.EosolBuyPriceLM || '' }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{
                                trans(
                                    'pages.profilepage.fields.eosol_buy_price_lm_coating'
                                )
                            }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.EosolBuyPriceLMCoating || '' }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.profilepage.fields.price4_net') }}
                        </div>
                        <div class="profilepagevalue">{{ formatPrice(profile.price4) }}</div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.profilepage.fields.mm_vp') }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.mmPrice }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.profilepage.fields.mm_price_lm') }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.mmPriceLM || '' }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{
                                trans(
                                    'pages.profilepage.fields.mm_price_lm_coating'
                                )
                            }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.mmPriceLMCoating || '' }}
                        </div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{
                                trans(
                                    'pages.profilepage.fields.gross_purchase_price'
                                )
                            }}
                        </div>
                        <div class="profilepagevalue">{{ profile.bruto }}</div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{
                                trans(
                                    'pages.profilepage.fields.net_purchase_price'
                                )
                            }}
                        </div>
                        <div class="profilepagevalue">{{ profile.netto }}</div>
                    </div>
                    <div class="profilepagefield">
                        <div class="profilepagename">
                            {{ trans('pages.profilepage.fields.eosol_ap') }}
                        </div>
                        <div class="profilepagevalue">
                            {{ profile.eosolBuyPrice }}
                        </div>
                    </div>
                </template>
                <h2>{{ trans('pages.profilepage.fields.technical_data') }}</h2>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.profile_length') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.length }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.profile_width') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.width }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.profile_height') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.height }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.contour') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.contour }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.contour2') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.contour2 }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.weight_lm') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.weightLM }}</div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.round_to_mm') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.roundToLength }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.round_from_mm') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.minLengthToRound }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.process_as_part') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            profile.isPart == 1
                                ? trans('pages.profilepage.fields.true')
                                : trans('pages.profilepage.fields.false')
                        }}
                    </div>
                </div>
                <h2>{{ trans('pages.profilepage.fields.platform') }}</h2>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.active') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            profile.active == 1
                                ? trans('pages.profilepage.fields.true')
                                : trans('pages.profilepage.fields.false')
                        }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.prosite_mm') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            profile.prosite == 1
                                ? trans('pages.profilepage.fields.true')
                                : trans('pages.profilepage.fields.false')
                        }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.prosite_eosol') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            profile.prositeEosol == 1
                                ? trans('pages.profilepage.fields.true')
                                : trans('pages.profilepage.fields.false')
                        }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.active_webshop') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            profile.webshop == 1
                                ? trans('pages.profilepage.fields.true')
                                : trans('pages.profilepage.fields.false')
                        }}
                    </div>
                </div>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.sort_value') }}
                    </div>
                    <div class="profilepagevalue">{{ profile.sortValue }}</div>
                </div>
                <h2>
                    {{ trans('pages.profilepage.fields.material_information') }}
                </h2>
                <div class="profilepagefield">
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.material_type') }}
                    </div>
                    <div class="profilepagevalue">
                        {{
                            profile.materialType
                                ? profile.materialType.name
                                : trans(
                                      'pages.profilepage.fields.no_material_type'
                                  )
                        }}
                    </div>
                </div>
                <div
                    class="profilepagefield"
                    v-if="profile.materialType"
                >
                    <div class="profilepagename">
                        {{ trans('pages.profilepage.fields.thickness') }}
                    </div>
                    <div class="profilepagevalue">
                        {{ profile.thickness || 0 }} mm
                    </div>
                </div>
                <div v-if="hasRight('administration')">
                    <h2>
                        {{ trans('pages.profilepage.fields.purchase_history') }}
                    </h2>
                    <crm-table
                        ref="orderHistoryTable"
                        :columns="orderHistoryTableColumns"
                        :items="orderHistoryItems"
                        :count="orderHistoryItemsCount"
                        :status="orderHistoryTableStatus"
                        @fetch="fetchOrderHistoryDebounced"
                        :default-filters="defaultOrderHistoryTableFilters"
                        :default-sort="defaultOrderHistoryTableFilters.sort"
                        :default-order="defaultOrderHistoryTableFilters.order"
                        :has-sticky="true"
                        :use-global-scroll="true"
                        :get-key="(item) => item.id"
                    >
                        <template v-slot:no-results>
                            {{
                                trans(
                                    'pages.profilepage.fields.no_purchase_history'
                                )
                            }}
                        </template>
                        <template v-slot:filter-status="props">
                            <ui5-select
                                @change="
                                    props.onInput(
                                        props.column.name,
                                        $event.detail.selectedOption.value
                                    )
                                "
                            >
                                <ui5-option
                                    v-for="[value, label] in Object.entries(
                                        statuses
                                    )"
                                    :value="value"
                                    :selected="props.value == value"
                                    :key="'row.' + props.id + 'status.' + value"
                                >
                                    {{ label }}
                                </ui5-option>
                            </ui5-select>
                        </template>
                        <template v-slot:filter-dateOrdered="props">
                            <ui5-date-picker
                                format-pattern="yyyy-MM-dd"
                                :value="props.value"
                                @change="
                                    props.onInput(
                                        props.column.name,
                                        $event.detail.value
                                    )
                                "
                            />
                        </template>
                        <template v-slot:filter-clearFilters="props">
                            <ui5-button
                                @click="$refs.orderHistoryTable.clearFilters()"
                            >
                                {{ trans('pages.profilepage.fields.reset') }}
                            </ui5-button>
                        </template>
                        <template v-slot:dateOrdered="props">
                            <td>
                                {{ getSlashDate(props.item.dateOrdered) }}
                            </td>
                        </template>
                        <template v-slot:amountOrdered="props">
                            <td>
                                <ui5-input
                                    type="number"
                                    @blur="updateOrderHistoryRecord(props.item)"
                                    @input="
                                        props.item.amountOrdered =
                                            $event.target.value
                                    "
                                    @click.stop="() => {}"
                                    :value="props.item.amountOrdered"
                                />
                            </td>
                        </template>
                        <template v-slot:pricePerUnit="props">
                            <td>
                                <ui5-input
                                    type="number"
                                    @blur="updateOrderHistoryRecord(props.item)"
                                    @input="
                                        props.item.pricePerUnit =
                                            $event.target.value
                                    "
                                    @click.stop="() => {}"
                                    :value="props.item.pricePerUnit"
                                />
                            </td>
                        </template>
                        <template v-slot:supplier="props">
                            <td>
                                {{ props.item.supplierName }}
                            </td>
                        </template>
                        <template v-slot:status="props">
                            <td>
                                {{ getStatusLabel(props.item.status) }}
                            </td>
                        </template>
                    </crm-table>
                </div>
            </div>
        </div>
        <div class="midcolumn">
            <p class="image-title">
                {{ trans('pages.profilepage.fields.image') }}
            </p>
            <img
                id="profilepageimage"
                :src="profile.cloudFrontPath"
                v-if="profile"
            />

            <p class="image-title">
                {{ trans('pages.profilepage.fields.coating_photo') }}
            </p>
            <img
                id="lakfotoimage"
                :src="profile.cloudFrontLakPath"
                v-if="profile"
            />
        </div>
    </div>
</template>
<script>
import ActionsMenu from '../components/ActionsMenu';
import ActionsMenuItem from '../components/ActionsMenuItem';
import exportApi from '../api/export';
import powderApi from '../api/powder';
import profileApi from '../api/profile';
import goodsTypeApi from '../api/goodsType';
import TranslationsDisplay from '../components/TranslationsDisplay';
import IdParamMixin from '../mixins/id-param';
import { mapGetters } from 'vuex';
import {
    showConfirmDialog,
    showInfoMessage,
    showErrorMessage,
} from '../dialogs';
import { dateToDmY } from '../helpers/DateHelper';
import { statuses } from './../shared/orderLineOverview';
import CrmTable from '../components/CrmTable';
import _ from 'lodash';
import { getSlashDate } from '../helpers/DateHelper';
import { clearedFilters } from '../shared/profileOrderHistoryTable';
import localization from '../mixins/localization';
import CurrencyHelper from '../helpers/CurrencyHelper';

export default {
    mixins: [IdParamMixin(), localization],
    components: {
        ActionsMenu,
        ActionsMenuItem,
        CrmTable,
        TranslationsDisplay,
    },
    computed: {
        ...mapGetters({
            hasRight: 'currentUser/hasRight',
        }),
        selectedPrinterPostParameter() {
            return this.$store.getters[
                'printers/getSelectedPrinterPostParameter'
            ]();
        },
        profileMainImageUrl() {
            return (
                Config.url +
                '/profile/fetchImage/?profileId=' +
                this.profile.profileId +
                '&random=' +
                Math.random()
            );
        },
        lakFotoUrl() {
            return (
                Config.url +
                '/profile/fetchLakfoto/?profileId=' +
                this.profile.profileId +
                '&random=' +
                Math.random()
            );
        },
        goodsTypeLabel() {
            if (!this.profile || !this.goodsTypes) {
                return null;
            }
            const id = this.profile.goodsTypeId;
            if (!id) {
                return null;
            }
            const type = this.goodsTypes.find((x) => x.id == id);
            return type ? type.label : '';
        },
        fetchOrderHistoryDebounced() {
            return _.debounce(this.fetchOrderHistory, 500);
        },
        statuses: () => statuses,
    },
    data() {
        return {
            profile: null,
            goodsTypes: null,
            orderHistoryTableStatus: 'running',
            orderHistoryItems: [],
            orderHistoryItemsCount: 0,
            orderHistoryTableColumns: [
                {
                    name: 'dateOrdered',
                    label: this.trans('pages.profilepage.fields.order_date'),
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'amountOrdered',
                    label: this.trans('pages.profilepage.fields.amount'),
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'pricePerUnit',
                    label: this.trans(
                        'pages.profilepage.fields.net_purchase_price'
                    ),
                    searchable: true,
                    sortable: true,
                },
                {
                    name: 'supplierName',
                    label: this.trans('pages.profilepage.fields.supplier'),
                    searchable: true,
                    sortable: true,
                },
                {
                    backendColumn: 'status',
                    name: 'status',
                    label: this.trans('pages.profilepage.fields.status'),
                    searchable: true,
                    sortable: true,
                },
            ],
            defaultOrderHistoryTableFilters: {
                ...clearedFilters,
            },
        };
    },
    mounted() {
        goodsTypeApi.fetchAll().then((response) => {
            this.goodsTypes = response.data.data;
        });
        this.prepareOrderHistoryTable();
    },
    methods: {
        getSlashDate,
        formatPrice(value) {
            return CurrencyHelper.formatPrice(value, this.currentLocaleIso2Code());
        },
        getStatusLabel(key) {
            // get by object key
            return statuses[key];
        },
        load() {
            profileApi.fetch(this.idParam).then((response) => {
                const profile = response.data.data;
                this.profile = profile;
                this.$store.commit(
                    'general/setPageTitle',
                    `${this.trans('pages.profilepage.messages.profile')} ${
                        profile.code
                    } ${profile.description}`,
                    { root: true }
                );
            });
        },
        openTechnical() {
            window.open(
                +Config.url +
                    '/resources/profiles/' +
                    this.profile.technicalFichePath
            );
        },
        getFormattedDate: dateToDmY,
        exportKanbanLabel() {
            window.open(
                Config.url +
                    '/export/exportProfileKanbanLabel/?profileId=' +
                    this.idParam
            );
        },
        printKanban() {
            KeyHelper.handlePrintOrExport(
                () => exportApi
                    .printProfileKanbanLabel(this.idParam, this.selectedPrinterPostParameter)
                    .then(() => {
                        showInfoMessage(this.trans('pages.profilepage.messages.labels_printed'));
                    }),
                Config.url + '/export/exportProfileKanbanLabel/?profileId=' + this.idParam
            );
        },
        printProfileLabelClick() {
            if (this.profile.isPowder === true) {
                showConfirmDialog({
                    title: this.trans(
                        'pages.profilepage.messages.update_product'
                    ),
                    content: this.trans(
                        'pages.profilepage.messages.update_powder_products'
                    ),
                    confirm: (dialog) => {
                        dialog.close();
                        showInfoMessage(
                            this.trans(
                                'pages.profilepage.messages.products_updating'
                            )
                        );
                        powderApi
                            .updatePowderDelivered(this.idParam)
                            .then(this.printProfileLabel);
                    },
                    cancel: (dialog) => {
                        dialog.close();
                        this.printProfileLabel();
                    },
                    confirmButton: this.trans(
                        'pages.profilepage.messages.update'
                    ),
                    cancelButton: this.trans(
                        'pages.profilepage.messages.cancel'
                    ),
                });
            } else {
                this.printProfileLabel();
            }
        },
        printProfileLabel() {
            KeyHelper.handlePrintOrExport(
                () => exportApi
                    .printProfileLabel(this.idParam, this.selectedPrinterPostParameter)
                    .then(() => {
                        showInfoMessage(this.trans('pages.profilepage.messages.labels_printed'));
                    }),
                Config.url + '/export/exportProfileLabel/?profileId=' + this.idParam
            );
        },
        removeProfile() {
            showConfirmDialog({
                title: this.trans('pages.profilepage.messages.remove_profile'),
                content: this.trans(
                    'pages.profilepage.messages.confirm_remove_profile'
                ),
                confirm: (dialog) => {
                    dialog.close();
                    profileApi.removeProfile(this.idParam).then(() => {
                        this.$router.push('/stockcount');
                    });
                },
                cancel: (dialog) => {
                    dialog.close();
                },
                confirmButton: this.trans('pages.profilepage.messages.remove'),
                cancelButton: this.trans('pages.profilepage.messages.cancel'),
            });
        },
        prepareOrderHistoryTable() {
            this.initialOrderHistoryTableFilters =
                this.$store.getters['profileOrderHistoryTable/getFilters'];
        },
        fetchOrderHistory(filters) {
            if (!this.hasRight('administration')) {
                return;
            }

            this.orderHistoryTableStatus = 'running';

            this.$store.commit('profileOrderHistoryTable/setFilters', filters, {
                root: true,
            });

            if (filters.page === 1) {
                this.orderHistoryItems = [];
            }

            // Filter out empty values
            const queryParameters = Object.fromEntries(
                Object.entries(filters).filter(
                    ([_, v]) => v !== '' && v !== null
                )
            );

            profileApi
                .fetchOrderHistory(this.idParam, queryParameters)
                .then((response) => {
                    this.orderHistoryItems = [
                        ...this.orderHistoryItems,
                        ...response.data.data,
                    ];
                    this.orderHistoryItemsCount = response.data.meta.total;
                    this.orderHistoryTableStatus = 'success';
                })
                .catch((error) => {
                    this.orderHistoryTableStatus = 'error';
                    console.error(error);
                });
        },
        updateOrderHistoryRecord(record) {
            profileApi
                .updateOrderHistoryRecord(record.profileId, record.id, {
                    amountOrdered: record.amountOrdered,
                    pricePerUnit: record.pricePerUnit,
                })
                .then(() => {
                    showInfoMessage(
                        this.trans(
                            'pages.profilepage.messages.purchase_history_updated'
                        )
                    );
                })
                .catch((error) => {
                    console.error(error);
                    showErrorMessage(
                        this.trans(
                            'pages.profilepage.messages.purchase_history_update_failed'
                        )
                    );
                });
        },
    },
};
</script>
